import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { request } from '../smart_bps/lib/utils'

/**
 * Кнопка очереди принятия карточек на себя (верхняя панель, стиль как у вкладок-чипов).
 */
export default function AcceptQueueTopButton({
  projectName,
  label,
  countUrl,
  takeUrl,
  refreshKey,
}) {
  const navigate = useNavigate()
  const [count, setCount] = useState(null)
  const [loading, setLoading] = useState(false)

  const loadCount = useCallback(() => {
    request({
      method: 'get',
      url: countUrl,
      success: (data) => {
        setCount(typeof data?.count === 'number' ? data.count : 0)
      },
      error: () => setCount(0),
    })
  }, [countUrl])

  useEffect(() => {
    loadCount()
  }, [loadCount, refreshKey])

  const handleClick = () => {
    if (loading || !count) return
    setLoading(true)
    request({
      method: 'post',
      url: takeUrl,
      success: (data) => {
        setLoading(false)
        loadCount()
        if (data?.document_id) {
          navigate(`/${projectName}/${data.document_id}`)
        }
      },
      error: () => {
        setLoading(false)
        loadCount()
      },
    })
  }

  if (count === null || count === 0) {
    return null
  }

  return (
    <button
      type="button"
      className="btn btn-sm btn-primary me-1"
      disabled={loading}
      onClick={handleClick}
    >
      {label} ({count})
    </button>
  )
}
